export const LOGIN = 'LOGIN';
export const REGISTER = 'REGISTER';
export const LOGOUT = 'LOGOUT';
export const PASSWORD_CHANGED = 'PASSWORD_CHANGED';
export const PERMISSION_RELOADED = 'PERMISSION_RELOADED';